import { render, staticRenderFns } from "./TrainingGallery.vue?vue&type=template&id=4b551492&"
import script from "./TrainingGallery.vue?vue&type=script&lang=js&"
export * from "./TrainingGallery.vue?vue&type=script&lang=js&"
import style0 from "./TrainingGallery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports